import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { TextFormat, Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { APP_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './mandate.reducer';

export const MandateDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const mandateEntity = useAppSelector(state => state.mandate.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="mandateDetailsHeading">
          <Translate contentKey="crawlerBackendApp.mandate.detail.title">Mandate</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{mandateEntity.id}</dd>
          <dt>
            <span id="bankAccountId">
              <Translate contentKey="crawlerBackendApp.mandate.bankAccountId">Bank Account Id</Translate>
            </span>
          </dt>
          <dd>{mandateEntity.bankAccountId}</dd>
          <dt>
            <span id="mandateReference">
              <Translate contentKey="crawlerBackendApp.mandate.mandateReference">Mandate Reference</Translate>
            </span>
          </dt>
          <dd>{mandateEntity.mandateReference}</dd>
          <dt>
            <span id="status">
              <Translate contentKey="crawlerBackendApp.mandate.status">Status</Translate>
            </span>
          </dt>
          <dd>{mandateEntity.status}</dd>
          <dt>
            <span id="signatureId">
              <Translate contentKey="crawlerBackendApp.mandate.signatureId">Signature Id</Translate>
            </span>
          </dt>
          <dd>{mandateEntity.signatureId}</dd>
          <dt>
            <span id="signedAt">
              <Translate contentKey="crawlerBackendApp.mandate.signedAt">Signed At</Translate>
            </span>
          </dt>
          <dd>
            {mandateEntity.signedAt ? (
              <TextFormat value={mandateEntity.signedAt} type="date" format={APP_DATE_FORMAT} />
            ) : null}
          </dd>
          <dt>
            <span id="entranceCode">
              <Translate contentKey="crawlerBackendApp.mandate.entranceCode">Entrance Code</Translate>
            </span>
          </dt>
          <dd>{mandateEntity.entranceCode}</dd>
          <dt>
            <span id="createdAt">
              <Translate contentKey="crawlerBackendApp.mandate.createdAt">Created At</Translate>
            </span>
          </dt>
          <dd>
            {mandateEntity.createdAt ? (
              <TextFormat value={mandateEntity.createdAt} type="date" format={APP_DATE_FORMAT} />
            ) : null}
          </dd>
          <dt>
            <span id="updatedAt">
              <Translate contentKey="crawlerBackendApp.mandate.updatedAt">Updated At</Translate>
            </span>
          </dt>
          <dd>
            {mandateEntity.updatedAt ? (
              <TextFormat value={mandateEntity.updatedAt} type="date" format={APP_DATE_FORMAT} />
            ) : null}
          </dd>
          <dt>
            <span id="transactionUrl">
              <Translate contentKey="crawlerBackendApp.mandate.transactionUrl">Transaction Url</Translate>
            </span>
          </dt>
          <dd>{mandateEntity.transactionUrl}</dd>
          <dt>
            <span id="mandateTransactionCreateRequestKey">
              <Translate contentKey="crawlerBackendApp.mandate.mandateTransactionCreateRequestKey">
                Mandate Transaction Create Request Key
              </Translate>
            </span>
          </dt>
          <dd>{mandateEntity.mandateTransactionCreateRequestKey}</dd>
          <dt>
            <span id="mandateTransactionResponseKey">
              <Translate contentKey="crawlerBackendApp.mandate.mandateTransactionResponseKey">
                Mandate Transaction Response Key
              </Translate>
            </span>
          </dt>
          <dd>{mandateEntity.mandateTransactionResponseKey}</dd>
          <dt>
            <span id="mandateStatusResponseKey">
              <Translate contentKey="crawlerBackendApp.mandate.mandateStatusResponseKey">
                Mandate Status Response Key
              </Translate>
            </span>
          </dt>
          <dd>{mandateEntity.mandateStatusResponseKey}</dd>
        </dl>
        <Button tag={Link} to="/mandate" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/mandate/${mandateEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default MandateDetail;
